import {type MechanicLargestArmyPlayerState, type MechanicLargestArmyState, PlayerColor} from '@colonist/game-states'
import {MechanicValidator} from './MechanicValidator.ts'
import {type PlayerValidator} from '../core/PlayerValidator.ts'
import {type MapValidator} from '../core/map/MapValidator.ts'

export class MechanicValidatorLargestArmy extends MechanicValidator {
    private readonly largestArmyState: MechanicLargestArmyState

    constructor(playerValidators: PlayerValidator[], mapValidator: MapValidator, largestArmyState: MechanicLargestArmyState) {
        super(playerValidators, mapValidator)

        this.largestArmyState = largestArmyState
    }

    getLargestArmyPlayerState(player: PlayerColor): MechanicLargestArmyPlayerState {
        if(player == PlayerColor.None) return {}

        const largestArmyPlayerState = this.largestArmyState[player]
        if(largestArmyPlayerState === undefined) throw new Error(`No largestArmyPlayerState for player ${player}`)

        return largestArmyPlayerState
    }

    getPlayerWithLargestArmy(): PlayerColor {
        for(const key in this.largestArmyState) {
            const playerColor = Number(key) as PlayerColor
            const largestArmyPlayerState = this.getLargestArmyPlayerState(playerColor)
            if(largestArmyPlayerState.hasLargestArmy) return playerColor
        }
        return PlayerColor.None
    }

    doesBankHaveLargestArmyCard(): boolean {
        const playerWithLargestArmyCard = this.getPlayerWithLargestArmy()
        return playerWithLargestArmyCard == PlayerColor.None
    }
}
